import { Resource } from "react-admin";
import { Vehicle } from "../providers/vehiclesProvider";
import { useNavigate, useLocation } from "react-router";
import { useEffect } from "react";
import { DefaultList } from "../misc/DefaultList";
import { useRecordAndSwitchDrivingSchoolIfNecessary } from "../hooks/useRecordAndSwitchDrivingSchoolIfNecessary";
import { LoadingIndicator } from "../misc/LoadingIndicator";
import { englishPlural } from "../utils/englishPlural";

function _Redirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const vehicle = useRecordAndSwitchDrivingSchoolIfNecessary<Vehicle>((it) => it.drivingSchoolId);
  useEffect(() => {
    if (vehicle) {
      navigate(`/${englishPlural(vehicle.type)}/${vehicle.id}${location.search}${location.hash}`, { replace: true });
    }
  }, [vehicle]);

  return <LoadingIndicator />;
}

export const vehiclesResource = (
  <Resource
    key="vehicles"
    name="vehicles"
    list={DefaultList}
    edit={_Redirect}
    recordRepresentation={(vehicle: Vehicle) =>
      vehicle.plateNumber ? `${vehicle.name} (${vehicle.plateNumber})` : vehicle.name
    }
  />
);
